import React from "react";
import "./style.css";
import {formatCheeseName, generatePayImageName} from "../../../../../../utils/common";
import {Image} from "../../../../../../components/Image";

export const Container = ({data}) => {
  const renderCurBodyType = () => {
    if (data.gender === 'male') {
        if (data.currentBodyType === "skinny") {
          return "6-10%";
        } else if (data.currentBodyType === "regular") {
          return "13-20%";
        } else if (data.currentBodyType === "extra") {
          return "25-30%";
        }
    }  else if (data.gender === "female") {
        if (data.currentBodyType === "regular") {
            return "25%-31%";
        } else if (data.currentBodyType === "plump") {
            return "32%-35%";
        } else if (data.currentBodyType === "extra") {
            return "35%+";
        }
    }

    return "";
  };
  const renderTargetBodyType = () => {
    if (data.gender === 'male') {
      if (data.targetBodyType === "cut") {
        return "7-12%";
      } else if (data.targetBodyType === "bulk") {
        return "9-14%";
      } else if (data.targetBodyType === "extra_bulk") {
        return "8-15%";
      }
    } else if (data.gender === "female") {
        if (data.targetBodyType === "fit") {
            return "10%-13%";
        } else if (data.targetBodyType === "muscular") {
            return "14%-20%";
        } else if (data.targetBodyType === "shapely") {
            return "21%-24%";
        }
    }
    return "";
  }



  return (
    <div className="pay-container">
      <div className="div-2">
        <div className="frame-2">
          <div className="frame-3">
            <div className="current-state-wrapper">
              <div className="current-state">Now</div>
            </div>
          </div>

          <div className="frame-4">
            <div className="goal-state-wrapper">
              <div className="goal-state">Your Goal</div>
            </div>
          </div>
        </div>

        <div className="div-3">
          <div className="div-4">
            <Image src="/static/image/questionnaire/weight-loss/payScreen/container.png" alt="Container" className="img" />

            <div className="img-wrapper">
              <Image src={`/static/image/questionnaire/weight-loss/payScreen/${generatePayImageName(data.gender, data.currentBodyType, data.age)}`} alt="Img" className="img-2" />
            </div>

            <div className="img-wrapper">
              <Image src={`/static/image/questionnaire/weight-loss/payScreen/${generatePayImageName(data.gender, data.targetBodyType, data.age)}`} alt="Img" className="img-2" />
            </div>
          </div>

          <div className="body-fat-container">
            <div className="body-fat-container-wrapper">
              <div className="body-fat-container-2">
                <div className="body-fat-label">Body Fat</div>

                <div className="body-fat-value">{renderCurBodyType()}</div>
              </div>
            </div>

            <div className="frame-5">
              <div className="body-fat-container-3">
                <div className="text-wrapper">Body Fat</div>

                <div className="body-fat-value">{renderTargetBodyType()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="disclaimer">
        This is not a guarantee or promise of results.
      </p>
    </div>
  );
};
